<template>
	<div class="map">
		<div ref="hereMap" :style="{width: this.width, height: this.height}"></div>
	</div>
</template>
<script>
import platForm from "../../utils/Here";
import {initializeHereMap} from "../../utils/HereMap";

export default {
	name: "RutifyHereMap",
	props: {
		name: String,
		lat: String,
		lng: String,
		zoom: String,
		width: String,
		height: String,
		theme: String,
		module: String,
	},
	data() {
		return {
			platForm: null,
		};
	},
	computed: {
		localeMap() {
			return this.$i18n.locale;
		},
	},
	async mounted() {
		this.$nextTick(() => (this.platForm = platForm));
		//Renderizar Componentes
		initializeHereMap({
			lat: this.lat,
			lng: this.lng,
			refs: this.$refs.hereMap,
			zoom: this.zoom,
			lang: this.localeMap,
			module: this.module,
		});
	},
};
</script>
